import { render } from "./ContractsList.vue?vue&type=template&id=f47ab4fa&ts=true"
import script from "./ContractsList.vue?vue&type=script&lang=ts"
export * from "./ContractsList.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__